import { dataHora } from '../../lib/datas'
import { TEXTOS } from '../../lib/glossario'
import type { LinhaPorRepositorio } from '../../types/repositorios'

const INTEIRO = new Intl.NumberFormat('pt-BR')

const CELULA = 'px-3 py-2 text-right tabular-nums text-slate-700'

/**
 * Uma linha por repositório com atividade no período.
 *
 * @param props as linhas
 * @returns a tabela, ou nada quando não houve atividade
 */
export function TabelaPorRepositorio({ linhas }: { linhas: LinhaPorRepositorio[] }) {
  const t = TEXTOS.repositorios
  if (linhas.length === 0) {
    return null
  }
  return (
    <section className="cartao overflow-x-auto" aria-label={t.secoes.repositorios}>
      <h2 className="px-4 pt-4 text-base font-semibold text-slate-900">{t.secoes.repositorios}</h2>
      <table className="mt-2 min-w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-left text-xs font-semibold text-slate-500">
            <th className="px-3 py-2">{t.repositoriosTab.colunas.repositorio}</th>
            <th className="px-3 py-2 text-right">{t.repositoriosTab.colunas.commits}</th>
            <th className="px-3 py-2 text-right">{t.repositoriosTab.colunas.integracoes}</th>
            <th className="px-3 py-2 text-right">{t.repositoriosTab.colunas.autores}</th>
            <th className="px-3 py-2">{t.repositoriosTab.colunas.ultimo}</th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((linha) => (
            <tr key={linha.repositorioId} className="border-b border-slate-100 last:border-0">
              <td className="px-3 py-2">
                <a
                  href={linha.url}
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium text-niteroi-700 underline underline-offset-2 hover:text-niteroi-900"
                >
                  {linha.nomeCompleto}
                </a>
              </td>
              <td className={`${CELULA} font-semibold text-slate-900`}>{INTEIRO.format(linha.commits)}</td>
              <td className={CELULA}>{INTEIRO.format(linha.integracoes)}</td>
              <td className={CELULA}>{INTEIRO.format(linha.autores)}</td>
              <td className="px-3 py-2 text-xs text-slate-600">{dataHora(linha.ultimoCommitEm)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  )
}
